import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center py-12 px-4" }


export default /*@__PURE__*/_defineComponent({
  __name: 'CartEmpty',
  setup(__props) {

// Stateless component

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "mb-4 text-4xl text-muted-foreground" }, [
      _createElementVNode("i", { class: "fas fa-shopping-cart" })
    ], -1),
    _createElementVNode("h3", { class: "mb-2 text-lg font-semibold text-foreground" }, " Your Cart is Empty ", -1),
    _createElementVNode("p", { class: "text-center text-sm text-muted-foreground" }, " Add items from the shop to get started ", -1)
  ]))]))
}
}

})